
import {Component, Mixins, Prop} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import {TaksitHesapAyarEntity} from "@/entity/TaksitHesapAyarEntity";
import {ayEkleTasmasiz} from "@/utils/taksitTarihi";

@Component({
  components: {Tutar, Dates}
})
export default class OzelTaksitlendirme extends Mixins(ObjectInputMixin) {
  @Prop() esasBorc!: number;
  @Prop({default: false}) disabledHesaplamaButton!: boolean;
  @Prop({default: 0}) existingLength!: number;
  @Prop({default: false}) canContinue!: boolean;

  localValue!: TaksitHesapAyarEntity;
  isError: boolean = false;
  hataMesaji = "Hesaplamada hata oluştu.";
  periyodlar = [
    {text: "Ay", value: "ay"},
    {text: "Hafta", value: "hafta"}
  ]
  sayisinaGoreHesapla:number=0
  tutarinaGoreHesapla:number=1

  mounted() {
    this.localValue.hesaplansin_mi = false;
    // Sıfırlama sonrası alanları tekrar doldurmak için defaultları ayarla
    if(this.localValue.taksit_periyodu==null){
      this.localValue.taksit_periyodu='ay'
    }
    if(this.localValue.taksit_periyod_sayisi==null){
      this.localValue.taksit_periyod_sayisi=1
    }
    // Harç gösterim bayrakları kayıtta yoksa varsayılan "gösterilsin" (true) olur.
    if (this.localValue.baro_vekalet_pulu_gosterilsin_mi == null) this.localValue.baro_vekalet_pulu_gosterilsin_mi = true;
    if (this.localValue.vekalet_suret_harci_gosterilsin_mi == null) this.localValue.vekalet_suret_harci_gosterilsin_mi = true;
    if (this.localValue.pesin_harc_gosterilsin_mi == null) this.localValue.pesin_harc_gosterilsin_mi = true;
  }
  get taksitTarihi(){
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const taksitBaslangicTarihi = tomorrow.toISOString().slice(0, 10);
    return taksitBaslangicTarihi
  }
  clickSayisinaGore(){
    this.$emit('changeTabs',this.sayisinaGoreHesapla)
  }
  clickTutarinaGore(){
    this.$emit('changeTabs',this.tutarinaGoreHesapla)
  }

  load() {
    if (!this.localValue.taksit_baslangic_tarihi) {
      this.isError = true;
      this.hataMesaji = "Başlangıç tarihini giriniz.";
      return false;
    }else if (!this.localValue.taksit_tutari) {
      this.isError = true;
      this.hataMesaji = "Taksit tutarını giriniz.";
      return false;
    }else if (!this.localValue.taksit_sayisi || Number(this.localValue.taksit_sayisi) <= 0) {
      this.isError = true;
      this.hataMesaji = "Taksit sayısını giriniz.";
      return false;
    }else if (this.localValue.taksit_tutari && this.esasBorc < this.localValue.taksit_tutari) {
      this.isError = true;
      this.hataMesaji = "Taksit tutarı kalan tutardan büyük olamaz.";
      return false;
    }else if(new Date(this.localValue.taksit_baslangic_tarihi)<new Date(this.taksitTarihi)){
      this.isError = true;
      this.hataMesaji = "Taksit Başlangıç tarihini doğru giriniz";
    }else{
      // İstek atma: yerelde N adet taksit oluştur (kullanıcının girdiği tutar ve sayısı)
      this.isError = false;
      const startDate = new Date(this.localValue.taksit_baslangic_tarihi as any);
      const perCount = Number(this.localValue.taksit_periyod_sayisi) || 1;
      const isMonth = (this.localValue.taksit_periyodu||'ay') === 'ay';

      const createItem = (date: Date, amount: number, indexValue: number) => ({
        index: indexValue,
        tarih: date.toISOString().slice(0,10),
        tutar: amount,
        faiz_isleyen_gun: 0,
        faiz_isletilecek_tutar: 0,
        isleyen_faiz: 0,
        isleyen_faiz_bsmv: null,
        toplam_faiz: 0,
        kalan_ana_para: 0,
        kalan_faiz: 0,
        toplam_borc: null,
        kalan_borc: 0,
        tahsil_harci: null,
      });
      const amount = Number(this.localValue.taksit_tutari) || 0;
      const count = Number(this.localValue.taksit_sayisi) || 1;
      const taksitler: any[] = [];
      const startIndex = Number(this.existingLength) || 0;
      for(let i=0;i<count;i++){
        // TDT-3234 (47958): ay taşmasız — 29.01'den sonra 01.03 değil 28.02.
        const d = isMonth ? ayEkleTasmasiz(startDate, i*perCount) : new Date(startDate);
        if(!isMonth) d.setDate(d.getDate() + (i*7*perCount));
        taksitler.push(createItem(d, amount, startIndex + i + 1));
      }

      this.$emit('ozelTaksit', taksitler);
    }

  }
}
